if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide(event) {
      if (event) {
        const target = event.target;
        if (target.nodeName != 'SLIDER-INDICATOR') {
          super.hide();
          document.body.classList.remove('modal-open');
        }
      } else {
        super.hide();
        document.body.classList.remove('modal-open');
      }
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      document.body.classList.add('modal-open');
    }

    showActiveMedia() {

      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )

      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.click();
    }
  });
}
